import { Injectable } from '@angular/core';

import {
    PcvizProject,
    PcvizApplication,
    PcvizJobSite,
    PcvizSceneView,
    PcvizTocView,
    PcvizJobSiteSceneView,
    PcvizTableView,
    PcvizJobSiteTableView,
} from '@mirage-projects/cw-models';

@Injectable({ providedIn: 'root' })
export class AppPcvizService {
    createApplicationFromProject(projectCore: PcvizProject): PcvizApplication {
        const app = new PointCloudViz.App.Application(projectCore);
        // Even if we pass the project to the constructor, it is necessary to execute the setProject method
        // because it initializes the OverwriteSymbologyController.
        app.setProject(projectCore);
        app.setResourcesPath('./assets');
        return app;
    }

    createApplicationFromJobSite(jobSiteCore: PcvizJobSite): PcvizApplication {
        const app = new PointCloudViz.App.Application();
        app.setJobSite(jobSiteCore);
        app.setResourcesPath('./assets');
        return app;
    }

    createSceneView(element: HTMLElement | null, projectCore: PcvizProject): PcvizSceneView {
        return new PointCloudViz.App.SceneView(element, projectCore);
    }

    createTableView(projectCore: PcvizProject): PcvizTableView {
        return new PointCloudViz.App.TableView(projectCore);
    }

    createJobSiteTableView(jobSiteCore: PcvizJobSite | null): PcvizJobSiteTableView {
        return new PointCloudViz.App.JobSiteTableView(jobSiteCore);
    }

    createTocView(projectCore: PcvizProject): PcvizTocView {
        return new PointCloudViz.App.TocView(projectCore);
    }

    createJobSiteSceneView(element: HTMLElement | null, jobSiteCore: PcvizJobSite): PcvizJobSiteSceneView {
        return new PointCloudViz.App.JobSiteSceneView(element, jobSiteCore);
    }
}
